type UTMKey = 'source' | 'campaign' | 'content';

export default function buildUTM(params: Record<UTMKey, string>): string {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      urlParams.append(`utm_${key}`, value);
    }
  });

  const queryString = urlParams.toString();
  return queryString ? `?${queryString}` : '';
}
